const AudioAssets = {
  background: 'assets/audio/background.wav'
}

export default AudioAssets
